const firebaseConfig = {
  apiKey: "AIzaSyAhezYScp7atOzmkVeHT3AffkjK7yDfrng",
  authDomain: "mobile-ticketing-development.firebaseapp.com",
  databaseURL: "https://mobile-ticketing-development.firebaseio.com",
  projectId: "mobile-ticketing-development",
  storageBucket: "mobile-ticketing-development.appspot.com",
};

export default firebaseConfig;
